import { Component, OnInit } from '@angular/core';
import { AuthService } from '@/core/services/auth.service';

@Component({
    selector: 'app-logout-page',
    templateUrl: './logout.component.html',
    // styleUrls: ['./logout.component.scss'],
    standalone: false,
})
export class LogoutComponent implements OnInit {
    constructor(private readonly authService: AuthService) {}

    ngOnInit(): void {
        this.authService.logout();
    }
}
